import styled from 'styled-components';
import { Button, theme } from '@veeqo/ui';
import TitleGroup from 'components/common/TitleGroup';

const Container = styled.div`
  width: 100%;
  max-width: 420px;
  margin-top: ${theme.sizes[18]};
`;

const SsoError = () => {
  const handleLoginRedirect = () => {
    window.location.href = '/signin';
  };

  return (
    <Container>
      <TitleGroup
        title="SSO Signup Not Available"
        subtitle="You cannot signup via SSO as an account with this email already exists. If you wish to enable SSO on this account, please login and verify your email, and then try again."
      />
      <Button variant="primary" onClick={handleLoginRedirect} role="link">
        Login
      </Button>
    </Container>
  );
};

export default SsoError;
